import { ProjectLogoName, ProjectLogoOption } from "../../../types";

export const logoNames:Array<ProjectLogoName> = ["logo_1", "logo_2"];
export const logoOptions:Array<ProjectLogoOption> = ["embroidered", "printed"];
